
<div class="video-component">

  <div #videoContainer class="video-container"
    [ngStyle]="{'border-color': AS.videoEnabled && AS.phoneStatus == phoneStatuses.TALKING ? 'red' : 'black'}"
    [hidden]="AS.appModes.includes(appModes.Photo)">

    <div id="videoThumbs">
      <ng-container #whiteboardSharedRef></ng-container>
      <div *ngIf="!config.iamOnCall" class="not-in-call">{{'Video.not_in_call' | translate}}</div>
      <ng-container #myVideoContainerRef></ng-container>

      <div id="remoteVideoThumbs" [hidden]="!config.iamOnCall">
      <ng-container #remoteVideoContainerRef></ng-container>
      </div>
    </div>

  </div>

  <app-caller-snapshot *ngIf="config.isCaller" [hidden]="!AS.appModes.includes(appModes.Photo)"
    [AS]="AS" [MYSTATUS]="MYSTATUS">
  </app-caller-snapshot>
</div>
